import React, { useEffect, useState } from "react";
import "./styles.scss";
import { NewsGroup, TrendingNewsCard } from "../../../components";
import { useHistory, withRouter } from "react-router-dom";
import { getLanguage } from "../../../utils/environment";
import { useDispatch, useSelector } from "react-redux";
import { getNewsByWidget } from "../../news/service/news.service";

const categoryId = process.env.REACT_APP_CABINET_NEWS;
const pageCount = process.env.REACT_APP_P_COUNT;

const lan = getLanguage();

const Index = ({ widgetId, news_id, title }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [news, setNews] = React.useState([]);
  const [menu, setMenu] = React.useState("");
  const [widgetNews, setWidgetNews] = useState([]);
  const [getWidget, setGetWidget] = useState("");

  const history = useHistory();
  const dispatch = useDispatch();

  const fetchWidgetNews = async (widget_id) => {
    try {
      const response = await getNewsByWidget(widget_id);
      console.log("get news", response);
      if (response?.data?.news) {
        setWidgetNews(response?.data?.news);
        setGetWidget(response?.data?.widget);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (widgetId) {
      fetchWidgetNews(widgetId);
    }
  }, [widgetId]);

  return (
    <>
      {/* {widgetNews.length > 0 && ( */}
      <NewsGroup
        data={{
          titleName: getWidget?.widget_name,
          mainType: "noBoarder",
          type: "en",
          linkName: "",
        }}
        is_header={getWidget?.widget_name ? true : false}
      >
        {widgetNews?.length > 0 && (
          <div className={`${getWidget?.widget_name ? "pl-2 pr-2" : ""}`}>
            {widgetNews
              .filter((news) => news.news_id !== news_id)
              .map((news, index) => {
                // Check if the item has updates
                const hasUpdates =
                  Array.isArray(news.updates) && news.updates.length > 0;

                // If updates exist, use the latest update (or modify as needed)
                const displayItem = hasUpdates
                  ? {
                      ...news,
                      ...news.updates[news.updates.length - 1],
                    }
                  : news;

                return (
                  <React.Fragment key={index}>
                    <TrendingNewsCard
                      data={{
                        isBorder: index + 1,
                        isTrendingNo: false,
                        // trendingNo: "",
                        trendingNo: false,
                        isDate: false,
                        img_url: displayItem?.images?.[0]?.url,
                        created_at: displayItem?.created_at,
                        header: displayItem?.title[lan],
                        content: displayItem?.content,
                        tagViews: displayItem?.views,
                        type: "related",
                      }}
                      onClick={() => {
                        const generatedSlug = displayItem?.title?.[lan]
                          ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                          ?.replace(/\//g, "")
                          ?.replace(/\s*-\s*/g, " ")
                          ?.trim()
                          .split(/\s+/)
                          .slice(0, 5)
                          .join("-")
                          .replace(/-+/g, "-");
                        history.push(
                          `/${generatedSlug}/${displayItem?.news_id}`
                        );
                      }}
                    />
                  </React.Fragment>
                );
              })}
          </div>
        )}
      </NewsGroup>
      {/* )} */}
    </>
  );
};
export default withRouter(Index);
